import { ServiceBase } from "@app/shared";
import { AiChatMessage } from "@app/projects/network-assessment/provider-hub/interfaces";

export default class ChatbotService extends ServiceBase {

  /**
   * Posts a conversation to be processed by Snowflake Cortex. The last prompt in the conversation must be unanswered.
   * The API responds with the last prompt answered by the LLM.
   */
  public async sendConversation(conversation: AiChatMessage[]): Promise<AiChatMessage[]> {
    return await this.makePost<AiChatMessage[]>(`chatbot/response`, conversation);
  }

  /**
   * Posts a message to the userguide chatbot.
   * @param message
   */
  public async sendUserguideMessage(message: AiChatMessage): Promise<AiChatMessage> {
    return await this.makePost<AiChatMessage>(`chatbot/userguide`, message);
  }

  /**
   * Posts a conversation to be processed by the Semantic Kernel.
   * @param conversation
   */
  public async sendSemanticKernalConversation(conversation: AiChatMessage[]): Promise<AiChatMessage[]> {
    return await this.makePost<AiChatMessage[]>(`chatbot/semantickernel`, conversation);
  }
}

